import Vue from 'vue'
import Vuetify, {
  VApp,
  VIcon,
  VCard,
  VSnackbar,
  VBtn,
  VChip,
  VSelect,
  VTextField,
  VDialog,
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VApp,
    VIcon,
    VCard,
    VSnackbar,
    VBtn,
    VChip,
    VSelect,
    VTextField,
    VDialog,
  },
})

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#00acef',
        blue: '#00acef',
        info: '#00acef',
        secondary: '#1867c0',
        indigo: '#04193f',
      },
      dark: {
        primary: '#00acef',
        blue: '#00acef',
        info: '#00acef',
        grey: '#212121',
        secondary: '#1867c0',
        indigo: '#fff',
      },
    },
  },
})
